import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const data = [
  { day: "Seg", value: 520 },
  { day: "Ter", value: 740 },
  { day: "Qua", value: 610 },
  { day: "Qui", value: 980 },
  { day: "Sex", value: 1320 },
  { day: "Sáb", value: 1840 },
  { day: "Dom", value: 920 },
];

export default function TicketsBarChart() {
  return (
    <ResponsiveContainer width="100%" height={260}>
      <BarChart data={data}>
        <XAxis dataKey="day" />
        <YAxis />
        <Tooltip />
        <Bar dataKey="value" fill="#7c3aed" radius={[8, 8, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
}
